var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.625 39.0694L45.1528 38.6528C43.8131 37.4592 42.6405 36.0904 41.6667 34.5833C40.6031 32.5035 39.9656 30.2323 39.7917 27.9028V21.0417C39.8009 17.3828 38.4736 13.8465 36.0594 11.0972C33.6451 8.34788 30.3099 6.57481 26.6806 6.11111V4.31945C26.6806 3.82769 26.4852 3.35608 26.1375 3.00835C25.7898 2.66063 25.3181 2.46528 24.8264 2.46528C24.3346 2.46528 23.863 2.66063 23.5153 3.00835C23.1676 3.35608 22.9722 3.82769 22.9722 4.31945V6.13889C19.3754 6.63601 16.0805 8.4198 13.698 11.1599C11.3154 13.8999 10.0066 17.4106 10.0139 21.0417V27.9028C9.83994 30.2323 9.20247 32.5035 8.13889 34.5833C7.18178 36.0866 6.02805 37.4552 4.70834 38.6528L4.23611 39.0694V42.9861H45.625V39.0694Z",
    fill: "#2A9D8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2778 44.4444C21.3996 45.3248 21.8358 46.1314 22.5059 46.7152C23.1761 47.299 24.0348 47.6206 24.9236 47.6206C25.8124 47.6206 26.6711 47.299 27.3413 46.7152C28.0114 46.1314 28.4476 45.3248 28.5694 44.4444H21.2778Z",
    fill: "#2A9D8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.0448fb086a8ab0bfa28695b304aadb07.svg";
export { ForwardRef as ReactComponent };